/**
 * API Endpoints Constants
 * Centralized endpoint definitions for better maintainability
 */

export const API_ENDPOINTS = {
  // Auth
  AUTH: {
    LOGIN: 'admin/adminLogin',
  },

  // Dashboard
  DASHBOARD: {
    BOOKING_HISTORY: 'admin/getBookingHistory',
    BOOKING_STATUS_COUNTS: 'admin/getBookingStatusCounts',
    DATA_BY_SERVICE_STATUS: 'admin/getAllDataByServiceStatus',
    TOTAL_EARNING: 'users/getTotalEarning',
    ALL_LENGTH: 'users/getAllLength',
    BOOKING_V1: 'users/getBooking_v1',
    CAR_IMAGE: 'vender/getCarImage',
    UPDATE_VENDER_ASSEN_WORK: 'admin/UpdateVenderAssenWork',
    ALL_VERIFIED_VENDER: 'admin/getAllVerifiedVender',
  },

  // Order of services in the apps
  SERVICE_ORDER: {
    LIST: 'admin/serviceOrder/list',
    HISTORY: 'admin/serviceOrder/history',
    MOVE: 'admin/serviceOrder/move',
    ARRANGE: 'admin/serviceOrder/arrange',
  },

  // Signed-in admin's account
  ACCOUNT: {
    CHANGE_PASSWORD: 'admin/account/changePassword',
  },

  // Global search
  SEARCH: {
    GLOBAL: 'admin/search',
  },

  // Analytics & Reports
  ANALYTICS: {
    FILTERS: 'admin/analytics/filters',
    OVERVIEW: 'admin/analytics/overview',
    REPORT: 'admin/analytics/report',
    PARTNERS: 'admin/analytics/partners',
    PARTNER: 'admin/analytics/partner',
  },

  // Workshop partner review
  PARTNERS: {
    PROFILE: 'admin/partners/profile',
    HISTORY: 'admin/partners/history',
    CHANGE_REQUESTS: 'admin/partners/changeRequests',
    LAST_OTPS: 'admin/partners/lastOtps',
    REVEAL_OTP: 'admin/partners/revealOtp',
    REVIEW_DOCUMENT: 'admin/partners/reviewDocument',
    REJECT: 'admin/partners/reject',
    REVIEW_CHANGE: 'admin/partners/reviewChange',
  },

  // Admin
  ADMIN: {
    ADD_NOTIFICATION_TOKEN: 'admin/addNotificationToken',
    GET_ALL_REZARPAY: 'admin/getAllRezarpay',
    UPDATE_REZARPAY: 'admin/updateRezarpay',
    ADD_REZARPAY: 'admin/addNewRezarpay',
    DELETE_VENDER: 'admin/deleteVender',
    GET_ALL_VENDER: 'admin/getAllVender',
    GET_ALL_PENDING_VENDER: 'admin/getAllPendingVender',
    GET_REGISTRATION_SETTING: 'admin/getRegistrationSetting',
    SET_GST_ENABLED: 'admin/setGstEnabled',
    UPDATE_VENDER_REGISTRATION: 'admin/updateVenderRegistration',
    APPROVE_VENDER: 'admin/approveVender',
    UPDATE_VENDER_DETAILS: 'vender/UpdateVenderDetails',
    UPDATE_USER_JOB_CART_APPROVED: 'users/updateUserJobCartApproved',
    GET_USER_MEMBERSHIP: 'admin/getUserMemberShip_v5',
  },

  // Services
  SERVICE: {
    GET_ALL: 'admin/getServiceCategory',
    ADD: 'admin/addNewServiceCategory',
    UPDATE: 'admin/updateServiceCategory',
    DELETE: 'admin/deleteServiceCategory',
    GET_SUB_CATEGORY: 'admin/getServiceSubCategoryWithCategoryId',
    UPDATE_BY_DISCOUNT: 'admin/updateServiceByDiscount',
    DELETE_REGULAR: 'admin/deleteRegulerService_v1',
  },

  // Car Management
  CAR: {
    BRAND: {
      GET_ALL: 'admin/getAllCarBrand',
      ADD: 'admin/addCarBrand',
      UPDATE: 'admin/updateCarBrand',
      DELETE: 'admin/deleteCarBrand',
    },
    MODEL: {
      GET_ALL: 'admin/getAllCarModel',
      GET_BY_BRAND: 'admin/getCarModelByCarBrandId',
      ADD: 'admin/addCarModel',
      UPDATE: 'admin/updateCarModel',
      DELETE: 'admin/deleteCarModel',
      UPDATE_IMAGE: 'admin/updateCarModelImage',
    },
    MODEL_FUEL: {
      GET_ALL: 'admin/getAllCarModelFuel',
      ADD: 'admin/addCarModelFuel',
      GET_FUEL_BY_MODEL: 'admin/getFuelTypesByCarModelId',
    },
    TYPE: {
      GET_ALL: 'admin/getAllCarType',
      ADD: 'admin/addCarType',
      UPDATE: 'admin/updateCarType',
      DELETE: 'admin/deleteCarType',
    },
    FUEL_TYPE: {
      GET_ALL: 'admin/getAllFuelType',
      ADD: 'admin/addFuelType',
      UPDATE: 'admin/updateFuelType',
      DELETE: 'admin/deleteFuelType',
    },
  },

  // City
  CITY: {
    GET_ALL: 'admin/getAllCity',
    ADD: 'admin/addNewCity',
    UPDATE: 'admin/updateCity',
    DELETE: 'admin/deleteCity',
  },

  // Users & Members
  USER: {
    GET_ALL: 'admin/getAllUser',
    GET_MEMBERS: 'admin/getAllMember',
    GET_MEMBERSHIP: 'admin/getUserMemberShip_v5',
  },

  // Membership
  MEMBERSHIP: {
    GET_ALL: 'admin/getAllMemberShip',
    ADD: 'admin/addMemberShip',
    UPDATE: 'admin/updateMemberShip',
    DELETE: 'admin/deleteMemberShip',
  },

  // Discount Coupon
  COUPON: {
    GET_ALL: 'admin/getAllDiscountCoupon',
    ADD: 'admin/addDiscountCoupon',
    UPDATE: 'admin/updateDiscountCoupon',
    DELETE: 'admin/deleteDiscountCoupon',
  },

  // Banner
  BANNER: {
    GET_ALL: 'admin/getAllBanner',
    ADD: 'admin/addBanner',
    UPDATE: 'admin/updateBanner',
    DELETE: 'admin/deleteBanner',
  },

  // SOS Emergency
  SOS: {
    GET_ALL: 'admin/getAllSOS',
    GET_EMERGENCY: 'admin/getAllSOSEmergency',
    UPDATE: 'admin/updateSOS',
    TIMELINE: 'admin/sos/timeline',
    ASSIGN: 'admin/sos/assign',
    REALLOCATE: 'admin/sos/reallocate',
    CANCEL: 'admin/sos/cancel',
    COMPLETE: 'admin/sos/complete',
    SETTINGS: 'admin/sos/settings',
    SAVE_SETTINGS: 'admin/sos/saveSettings',
    PARTNER_CONFIG: 'admin/sos/partnerConfig',
    SAVE_PARTNER_CONFIG: 'admin/sos/savePartnerConfig',
  },

  // Membership management (admin)
  MEMBERSHIP_ADMIN: {
    LIST: 'admin/memberships/list',
    DETAIL: 'admin/memberships/detail',
    AUDIT: 'admin/memberships/audit',
    OPTIONS: 'admin/memberships/options',
    ADD: 'admin/memberships/add',
    UPDATE: 'admin/memberships/update',
    DEACTIVATE: 'admin/memberships/deactivate',
    REACTIVATE: 'admin/memberships/reactivate',
    REMOVE: 'admin/memberships/remove',
  },
};

